import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { lookupsApi } from '../services/api';
import { useAuth } from './AuthContext';

const LookupContext = createContext(null);

export function LookupProvider({ children }) {
  const { user } = useAuth();
  const [lookups, setLookups] = useState({
    fileTypes:     [],
    orderStatuses: [],
    origSystems:   [],
    loanTypes:     [],
    lienStatuses:  [],
  });
  const [loading, setLoading] = useState(false);

  const fetchLookups = useCallback(async () => {
    setLoading(true);
    try {
      const data = await lookupsApi.getAll();
      setLookups(data);
    } catch (err) {
      console.error('Failed to load lookups', err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch whenever a user logs in; clear on logout
  useEffect(() => {
    if (user) fetchLookups();
    else setLookups({ fileTypes: [], orderStatuses: [], origSystems: [], loanTypes: [], lienStatuses: [] });
  }, [user, fetchLookups]);

  // Helper: resolve a name to its ID within a lookup list
  function lookupId(list, name) {
    return lookups[list]?.find(x => x.name === name)?.id ?? null;
  }

  // Helper: resolve an ID to its name within a lookup list
  function lookupName(list, id) {
    return lookups[list]?.find(x => x.id === id)?.name ?? '—';
  }

  // Active loan types only — for new/edit file dropdowns
  const activeLoanTypes = lookups.loanTypes.filter(x => x.isActive);

  return (
    <LookupContext.Provider value={{
      lookups,
      activeLoanTypes,
      loading,
      fetchLookups,
      lookupId,
      lookupName,
    }}>
      {children}
    </LookupContext.Provider>
  );
}

export function useLookups() {
  const ctx = useContext(LookupContext);
  if (!ctx) throw new Error('useLookups must be used within LookupProvider');
  return ctx;
}
